import React from "react";
import RedirectToLive from "../containers/RedirectToLive";

const ScratchResults = (props) => {
  const {
    EventName,
    scratchList,
    ExecuteUpdate,
  } = props;

  const content = scratchList.map((scratch, i) =>
    <tr key={i}>
      <td>{scratch.Rank}</td>
      <td>{scratch.RiderBib}</td>
      <td>{scratch.RiderName}</td>
      {/* <td>{scratch.RiderNOC}</td> */}
      <td>
        <img
          src={process.env.PUBLIC_URL + '/Flags/' + scratch.RiderNOC + '.bmp'}
          height="25"
          width="60"
          alt={scratch.RiderNOC}
        />
      </td>
      <td>{scratch.RiderLaps}</td>
    </tr>
  );

  const TableResults = () => {
    return (
      <div className="container">
        <h1>{EventName} Results</h1>
        <br />
        <br />
        <br />
        <table className="table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Bib</th>
              <th>Name</th>
              <th>Nation</th>
              <th>Laps</th>
            </tr>
          </thead>
          <tbody>
            {content}
          </tbody>
        </table>
        {/* {props.updatePage} */}
      </div>
    );
  }

  return (
    <div>
      <RedirectToLive Update={ExecuteUpdate} />
      <TableResults />
    </div>
  );
};

export default ScratchResults;  